export default __webpack_public_path__ + "static/assets/med_pill_round_in_L0_solid_m_01_f_mask.20962730.png";